import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with brand gradient overlay */}
      <div className="absolute inset-0 bg-brand-indigo"></div>
      <div className="absolute inset-0 bg-hero-gradient"></div>
      
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-brand-teal/20 rounded-full blur-3xl animate-float"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-aurora-blue/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-aurora-violet/10 rounded-full blur-2xl animate-float" style={{ animationDelay: '4s' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="animate-fade-in">
          {/* Logo/Brand */}
          <div className="mb-8">
            <div className="w-32 h-32 mx-auto mb-6 relative">
              {/* Soft glow background layers */}
              <div className="absolute inset-0 bg-brand-teal/10 rounded-full blur-2xl animate-pulse"></div>
              <div className="absolute inset-2 bg-aurora-blue/15 rounded-full blur-xl animate-float"></div>
              <div className="absolute inset-4 bg-aurora-violet/10 rounded-full blur-lg animate-float" style={{ animationDelay: '1s' }}></div>
              
              <img 
                src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/86126c0a2c4a8a5efa2a79660917f6e5.png" 
                alt="Whence Logo" 
                className="w-full h-full object-contain relative z-10 drop-shadow-2xl filter brightness-110 saturate-110"
                style={{ 
                  filter: 'drop-shadow(0 0 20px rgba(29, 211, 176, 0.4)) drop-shadow(0 0 40px rgba(0, 180, 216, 0.2)) brightness(1.1) saturate(1.1)' 
                }}
              />
            </div>
            <h1 className="text-6xl sm:text-7xl lg:text-8xl font-bold text-brand-off-white font-pacifico mb-4">
              Whence
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-brand-teal to-aurora-green mx-auto rounded-full"></div>
          </div>

          {/* Official Tagline */}
          <div className="mb-12 animate-slide-up" style={{ animationDelay: '0.3s' }}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-off-white mb-6 leading-tight">
              Welcome to the World of Whence
            </h2>
            <p className="text-xl sm:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-4">
              From AI to AGI, Whence is the bridge
            </p>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Know from whence
            </p>
          </div>

          {/* CTA Button */}
          <div className="animate-slide-up" style={{ animationDelay: '0.6s' }}>
            <Button
              variant="primary"
              size="lg"
              onClick={scrollToContact}
              className="text-xl px-12 py-4 hover:transform hover:scale-105 bg-brand-teal hover:bg-brand-teal/80"
            >
              <span className="mr-2">Join Us</span>
              <i className="ri-arrow-right-line"></i>
            </Button>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-brand-teal/70 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
